export default __webpack_public_path__ + "static/media/discount.fae7200b.svg";